import React, { Component } from 'react';
import { Text } from 'informed';

export class TextInput extends Component {
  componentDidMount() {
    const { name } = this.props;
    const input = document.querySelector(`.search-form__input#${name}`);

    input.addEventListener('focus', () => {
      input.previousSibling.classList.add('active');
    });

    input.addEventListener('blur', () => {
      input.previousSibling.classList.remove('active');
    });
  }

  render() {
    const { name, title, width } = this.props;

    return (
      <li className={`search-form__item ${width}`}>
        <label className="search-form__label" htmlFor={name}>
          {title}
        </label>
        <Text className="search-form__input" field={name} id={name} />
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Shared/TextInput.js